<!-- sku规格 -->
<template>
  <el-dialog
    :show-close="false"
    :visible.sync="visible"
     destroy-on-close
    :close-on-click-modal="false"
  >
    <div style="padding: 15px;">
      <p class="back_icon" @click="visible=false"><i class="el-icon-arrow-left"></i>Edit Variant</p>
      <div class="title">
        <div>Action</div>
        <div>Options name*</div>
        <div>Opitons value*</div>
      </div>
      <div id="character">
        <div class="content" v-for="(itm,i) in variantArr" :key="i" :data-id="i">
          <div class="el-icon-more"></div>
          <div>
            <el-select
              ref="createSelect"
              v-model="itm['variantName']"
              filterable
              allow-create
              @change="(e)=>changeVariant(e,itm)"
              default-first-option
              remote
              :remote-method="(e)=>checkOptionNameRepeat(e,itm)"
              placeholder="Select">
              <el-option
                v-for="item in itm['variantNameArr']"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div v-if="itm['isRepeat'] && itm['variantName']">You've already used the option name "{{itm['repeatValue']}}"</div>
            <div v-if="!itm['variantName']">Please select an option.</div>
          </div>
          <input-tag ref="input-tag" :index-str="itm['variantName']"  repeatMsg="You’ve already used the option value “{tag}”" placeholder="Type an options and press enter…" :delete-confirm-msg="itm['confirmMsg']" :tags="itm['tagArr']" @getTags="getTags"></input-tag>
          <div class="el-icon-delete" @click="removeRow(i,itm)"></div>
        </div>
      </div>

      <div class="add-option" v-if="isShowAddOption"><span @click="addMoreOption"><i class="el-icon-plus"/> Add another option</span></div>

      <div class="submit-info">
        <div v-show="isError">{{sumbitErrorMsg}}</div>
        <div @click="submit">Save Options</div>
      </div>

    </div>

  </el-dialog>
</template>

<script>
import {variantArr} from '../../utils/status'
import InputTag from '../components/form/input-tag'
import Sortable from 'sortablejs'
export default {
  components: {
    InputTag
  },
  props: {

  },
  data() {
    return {
      visible: false,
      variantArr: [],
      isShowAddOption: true,
      isError: false,
      sumbitErrorMsg: '',
      tempVariantArr: []
    }
  },
  created() {

  },
  mounted() {
  },
  filters: {

  },
  watch: {
    variantArr: {
      handler(o, n) {
        this.isShowAddOption = (o.length <= 2)
        this.tempVariantArr = this.variantArr
      },
      deep: true
    },
    visible: {
      handler(n, o) {
        if (n) {
          this.initDragSort()
        }
      },
      deep: true
    }

  },
  methods: {
    initDragSort() {
      console.log('拖拽character')
      // 支持拖拽排序
      let that = this
      this.$nextTick(() => {
        const el = document.getElementById('character')
        let sortable = Sortable.create(el, {
          onEnd: ({oldIndex, newIndex}) => {
            // 交换位置
            // const arr = this.variantArr
            // const page = arr[oldIndex]
            // arr.splice(oldIndex, 1)
            // arr.splice(newIndex, 0, page)
            // console.log(this.variantArr.map((item) => {
            //   return item.variantName
            // }))
            // debugger
            let newVariantArr = []
            // 获取拖动后的排序
            var arr = sortable.toArray()
            // arr数组里的值是 data-id 的顺序
            arr.forEach((item, index) => {
              newVariantArr.push(that.tempVariantArr[item])
            })
            that.tempVariantArr = newVariantArr
          }
        })
      })
    },
    submit() {
      this.isError = false
      this.variantArr = this.tempVariantArr
      if (this.variantArr.length == 0 || this.variantArr.some(info => !info.variantName)) {
        this.sumbitErrorMsg = 'Please select an option.'
        this.isError = true
        return
      }
      if (this.variantArr.some(info => (info.variantName && info.tagArr.length == 0))) {
        this.sumbitErrorMsg = 'Please enter an option Value.'
        this.isError = true
        return
      }
      this.$parent.combinationSku(this.variantArr)
      this.visible = false
    },
    /**
     * 初始化特征信息，编辑时
     * @param variantWithValuesListMap
     */
    initSkuVariant(variantWithValuesListMap) {
      this.variantArr = []

      if (variantWithValuesListMap.size > 0) {
        variantWithValuesListMap.forEach((variantValueList, variantName) => {
          let variantNameArr = [...variantArr]
          if (!variantNameArr.some(e => e['value'].toLowerCase() == variantName.trim().toLowerCase())) {
            const obj = {
              'value': variantName,
              'label': variantName
            }
            variantNameArr.push(obj)
          }
          this.createGroup(variantNameArr, variantName, variantValueList)
        })
      } else {
        let variantNameArr = [...variantArr]
        this.createGroup(variantNameArr, '', [])
      }
    },
    createGroup(variantNameArr, variantName, values) {
      const obj = {
        variantNameArr: [...variantNameArr],
        variantName: variantName,
        historyVariantName: variantName, // 上一个历史值
        confirmMsg: `You are about to delete all variants with the ${variantName} {value}. Deleted variants cannot be recovered.`,
        tagArr: [...values],
        isRepeat: false, // options name是否重复
        repeatValue: '' // 重复值
      }
      this.variantArr.push(obj)
      this.tempVariantArr = this.variantArr
    },
    removeRow(i, row) {
      this.$confirm('Are you sure you want to delete this option? Deleting it will result in the deletion of all variants that include this option.', '', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'confirm-btn',
        cancelButtonClass: 'cancel-btn',
        type: 'warning'
      }).then(() => {
        this.variantArr = this.variantArr.filter(f => f['variantName'] !== row['variantName'])
      }).catch(() => {
        console.log('取消删除')
      })
    },
    addMoreOption() {
      let existsNonSelect = this.variantArr.some(f => !f['variantName'])
      if (!existsNonSelect) {
        this.createGroup(variantArr, '', [])
      }
    },
    changeVariant(e, row) {
      row.isRepeat = false

      let filterArr = this.variantArr.filter(info => info.variantName == e)
      if (filterArr.length > 1) {
        row.isRepeat = true
        row.repeatValue = e
        row.variantName = row.historyVariantName
      } else {
        // 历史值更改为当前选中值，避免报错
        row.historyVariantName = e
        row.confirmMsg = `You are about to delete all variants with the ${e} {value}. Deleted variants cannot be recovered.`

        let str = e.replace(/[^a-zA-Z0-9]/g, '')
        if (!str) {
          row.variantName = ''
        }
      }
    },
    getTags(index, indexStr, tags) {
      this.variantArr.map((e, i) => {
        if (e['variantName'] == indexStr) {
          e.tagArr = tags
        }
        return e
      })

      // 清空组（注意：此处不能通过数组下标索引删除）
      if (!tags || tags.length == 0) {
        this.variantArr = this.variantArr.filter(e => e['variantName'] !== indexStr)
      }
      // 循环准备传参
    },
    checkOptionNameRepeat(inputStr, row) {
      let str = inputStr.replace(/[^a-zA-Z0-9]/g, '')
      if (str && str.trim()) {
        let sameList = this.variantArr.filter((e) => {
          return e['variantName'].toLowerCase() == str.trim().toLowerCase()
        })

        let curRowSameList = row['variantNameArr'].filter((e) => {
          return e['value'].toLowerCase() == str.trim().toLowerCase()
        })

        if (sameList.length > 0 || curRowSameList.length > 0) {
          row.isRepeat = true
          row.repeatValue = str
          row.variantName = row.historyVariantName
        } else {
          row.isRepeat = false
          row.variantName = str.trim()
          /* const obj = {
            'value': str,
            'label': str
          }
          row.variantNameArr.push(obj) */
        }
      } else {
        // 输入中文等显示空
        row.variantName = ''
      }
    }

  }
}
</script>

<style scoped lang="less">
.back_icon {
  font-size: 14px;
  font-family: Satoshi-Bold;
  font-weight: 500;
  color: #262b2f;
  cursor: pointer;
}
.title{
  margin-top: 30px;
}
.content{
  margin-top: 10px;
}
.title,.content{
  display: flex;
  >div:nth-child(1){
    width: 50px;
    display: flex;
    align-items: center;
    cursor: move;
  }
  >div:nth-child(2){
    width: 150px;
    div:nth-child(2){
      color: #F77073;
    }
  }
  >div:nth-child(3){
    width: calc(100% - 300px);
    margin-left: 15px;
  }
  >div:nth-child(4){
    margin-left: 5px;
    width: 15px;
    height: 38px;
    line-height: 38px;
    cursor: pointer;
  }
}

.add-option{
  margin-top: 20px;
  cursor: pointer;
}

.submit-info{
  margin-top: 100px;
  div{
    width: 100%;
    text-align: center;
  }
  div:nth-child(1){
    color: #F77073;
  }
  div:nth-child(2){
      height: 40px;
      line-height: 40px;
      background: #262B2F;
      color: #FFFFFF;
      cursor: pointer;
      border-radius: 3px;
      position: relative;
      margin-top: 5px;
  }

}

/deep/ .el-button--primary{
  background: #262B2F !important;
  color: #FFFFFF !important;
  border-color:#262B2F !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/spuDetails/sku-variant.vue